"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PrivacyOptionsIcon = function PrivacyOptionsIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "31",
    height: "14",
    viewBox: "0 0 31 14",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("g", {
    "clip-path": "url(#clip0_8186_8851)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.25703 12.7992H15.057L18.157 1.19922H8.25703C5.05703 1.19922 2.45703 3.79922 2.45703 6.99922C2.45703 10.1992 5.05703 12.7992 8.25703 12.7992Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M23.4568 0H8.25684C4.35684 0 1.25684 3.1 1.25684 7C1.25684 10.9 4.35684 14 8.25684 14H23.4568C27.3568 14 30.4568 10.9 30.4568 7C30.4568 3.1 27.2568 0 23.4568 0ZM2.45684 7C2.45684 3.8 5.05684 1.2 8.25684 1.2H18.1568L15.0568 12.8H8.25684C5.05684 12.8 2.45684 10.2 2.45684 7Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.4566 3.99961C25.6566 4.19961 25.6566 4.59961 25.4566 4.79961L23.3566 6.99961L25.5566 9.19961C25.7566 9.39961 25.7566 9.79961 25.5566 9.99961C25.3566 10.1996 24.9566 10.1996 24.7566 9.99961L22.5566 7.79961L20.3566 9.99961C20.1566 10.1996 19.7566 10.1996 19.5566 9.99961C19.3566 9.79961 19.3566 9.39961 19.5566 9.19961L21.6566 6.99961L19.4566 4.79961C19.2566 4.59961 19.2566 4.19961 19.4566 3.99961C19.6566 3.79961 20.0566 3.79961 20.2566 3.99961L22.4566 6.19961L24.6566 3.99961C24.8566 3.79961 25.2566 3.79961 25.4566 3.99961Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.5564 4.09922C13.7564 4.29922 13.8564 4.69922 13.6564 4.89922L9.45645 9.79922C9.35645 9.89922 9.25645 9.99922 9.15645 9.99922C8.95645 10.0992 8.65645 10.0992 8.45645 9.89922L6.25645 7.69922C6.05645 7.49922 6.05645 7.09922 6.25645 6.89922C6.45645 6.69922 6.85645 6.69922 7.05645 6.89922L8.85645 8.59922L12.6564 4.09922C12.8564 3.89922 13.2564 3.89922 13.5564 4.09922Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_8186_8851"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "30",
    height: "14",
    fill: "white",
    transform: "translate(0.856445)"
  }))));
};
var _default = exports.default = PrivacyOptionsIcon;